module.exports = __webpack_public_path__ + "leftCircle.3d0b7692.png";